import React, { Component, Fragment } from 'react'
import { Field } from 'redux-form'
import { renderSelectField } from './fields'
import { required } from './validators'

import DiscountOptionsModal from './DiscountOptionsModal'

import questionMarkIcon from '../../../assets/icons/questionMark.svg'

export default class GuestInfo extends Component {
  state = {
    isModalOpened: false,
    modalType: null
  }

  handleModalClose = e => {
    e.preventDefault()
    this.setState({ isModalOpened: false })
  }

  handleModalOpen = e => {
    this.setState({ isModalOpened: true, modalType: e.target.dataset.type })
  }

  render() {
    return (
      <>
        <div className="equote-package-additional-details-form--discount">
          <div className="equote-package-additional-details-form--input-group">
            <label className="equote-package-additional-details-form--input-group--label">
              GUEST
              <br /> INFORMATION <span style={{ color: 'red' }}>*</span>
            </label>
            <div className="equote-package-additional-details-form--numberOfGuests--container">
              <div
                className="equote-package-additional-details-form--numberOfGuests"
                style={{ minHeight: '50px' }}
              >
                <Field
                  name="Number Of Guests"
                  component={renderSelectField}
                  validate={required}
                  options={[
                    {
                      value: '',
                      label: 'Number of Guests'
                    },
                    {
                      value: 1,
                      label: '1'
                    },
                    {
                      value: 2,
                      label: '2'
                    },
                    {
                      value: 3,
                      label: '3'
                    },
                    {
                      value: 4,
                      label: '4'
                    },
                    {
                      value: 5,
                      label: '5'
                    },
                    {
                      value: 'More',
                      label: 'More'
                    }
                  ]}
                />
              </div>
              <div className="equote-package-additional-details-form--criteria">
                <p>Do any guests meet the following criteria?</p>
                <span
                  style={{ alignSelf: 'flex-start' }}
                  onClick={this.handleModalOpen}
                  data-type="Age 55+"
                  className="equote-package-additional-details-form--input-group-link"
                >
                  <img
                    alt="question mark"
                    src={questionMarkIcon}
                    height="5"
                    width="5"
                  />{' '}
                  Why we ask
                </span>
              </div>

              <div className="u-package-forms-radio-group-label--container">
                <div className={`u-package-forms-radio-group u-flex-container`}>
                  <label className="u-package-forms-radio-group-label">
                    <Field
                      name="Senior"
                      component="input"
                      type="checkbox"
                      className="u-package-forms-radio-group-input"
                    />
                    Age 55+
                  </label>
                </div>

                {this.props.canUsePromoQualifiers && (
                  <Fragment>
                    <div
                      className={`u-package-forms-radio-group u-flex-container`}
                    >
                      <label className="u-package-forms-radio-group-label">
                        <Field
                          name="Law Enforcement Discount"
                          component="input"
                          type="checkbox"
                          className="u-package-forms-radio-group-input"
                        />
                        U.S. or Canadian Law Enforcement
                      </label>
                    </div>
                    <div
                      className={`u-package-forms-radio-group u-flex-container`}
                    >
                      <label className="u-package-forms-radio-group-label">
                        <Field
                          name="Fire Department or EMT Discount"
                          component="input"
                          type="checkbox"
                          className="u-package-forms-radio-group-input"
                        />
                        Fire Department or EMT
                      </label>
                    </div>
                    <div
                      className={`u-package-forms-radio-group u-flex-container`}
                    >
                      <label className="u-package-forms-radio-group-label">
                        <Field
                          name="Police Department Discount"
                          component="input"
                          type="checkbox"
                          className="u-package-forms-radio-group-input"
                        />
                        U.S. Military or Canadian Forces
                      </label>
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
        <DiscountOptionsModal
          isOpen={this.state.isModalOpened}
          onRequestClose={this.handleModalClose}
          modalType={this.state.modalType}
          canUsePromoQualifiers={this.props.canUsePromoQualifiers}
        />
      </>
    )
  }
}
